import { render } from "./VentasCreateCredito.vue?vue&type=template&id=34c4182a&scoped=true"
import script from "./VentasCreateCredito.vue?vue&type=script&lang=js"
export * from "./VentasCreateCredito.vue?vue&type=script&lang=js"

import "./VentasCreateCredito.vue?vue&type=style&index=0&id=34c4182a&scoped=true&lang=css"

import exportComponent from "/home/runner/work/system-jj-frontend/system-jj-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34c4182a"]])

export default __exports__